import { render, staticRenderFns } from "./todayEvent.vue?vue&type=template&id=4ba0de72&scoped=true&"
import script from "./todayEvent.vue?vue&type=script&lang=js&"
export * from "./todayEvent.vue?vue&type=script&lang=js&"
import style0 from "./todayEvent.vue?vue&type=style&index=0&id=4ba0de72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba0de72",
  null
  
)

export default component.exports